var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "location-search" },
      [
        _c("ValidationProvider", {
          attrs: { name: "Location", rules: "required" },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function ({ failed, errors }) {
                return [
                  _c(
                    "FormGroup",
                    {
                      staticClass: "mb-4",
                      attrs: {
                        id: "location",
                        title: "",
                        errors: errors,
                        inputClass: "fullwidthInput",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function () {
                              return [
                                _c("p", { staticClass: "mb-2" }, [
                                  _c("span", { staticClass: "required-icon" }, [
                                    _vm._v("*"),
                                  ]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.isClient ? "Address" : "Location"
                                      ) +
                                      " "
                                  ),
                                  !_vm.isClient
                                    ? _c(
                                        "span",
                                        { staticClass: "subLocation" },
                                        [
                                          _vm._v(
                                            "(Confirm visit location. If it is different, start typing to update it)"
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [
                      _c("FormInputGroup", {
                        attrs: {
                          name: "location",
                          placeholder: "Select location",
                          type: "text",
                          invalid: failed,
                          inputClass: "fullwidthInputCustom",
                          inputClasses: "pl-3",
                          withIcon: true,
                          autocomplete: "off",
                        },
                        on: { input: _vm.fetchSuggestions },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "icon",
                              fn: function () {
                                return [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "16",
                                        height: "22",
                                        viewBox: "0 0 16 22",
                                        fill: "none",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d: "M8.9875 20.8C11.125 18.125 16 11.6417 16 8C16 3.58333 12.4167 0 8 0C3.58333 0 0 3.58333 0 8C0 11.6417 4.875 18.125 7.0125 20.8C7.525 21.4375 8.475 21.4375 8.9875 20.8ZM8 5.33333C8.70724 5.33333 9.38552 5.61428 9.88562 6.11438C10.3857 6.61448 10.6667 7.29276 10.6667 8C10.6667 8.70724 10.3857 9.38552 9.88562 9.88562C9.38552 10.3857 8.70724 10.6667 8 10.6667C7.29276 10.6667 6.61448 10.3857 6.11438 9.88562C5.61428 9.38552 5.33333 8.70724 5.33333 8C5.33333 7.29276 5.61428 6.61448 6.11438 6.11438C6.61448 5.61428 7.29276 5.33333 8 5.33333Z",
                                          fill: "black",
                                          "fill-opacity": "0.25",
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          true
                        ),
                        model: {
                          value: _vm.query,
                          callback: function ($$v) {
                            _vm.query = $$v
                          },
                          expression: "query",
                        },
                      }),
                      _vm.suggestions.length
                        ? _c(
                            "ul",
                            { staticClass: "suggestions-list" },
                            _vm._l(
                              _vm.suggestions,
                              function (suggestion, index) {
                                return _c(
                                  "li",
                                  {
                                    key: index,
                                    on: {
                                      click: function ($event) {
                                        return _vm.selectLocation(suggestion)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(suggestion.description) + " "
                                    ),
                                  ]
                                )
                              }
                            ),
                            0
                          )
                        : _vm._e(),
                      _vm.addressError
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "mt-2 p-3 bg-red-50 border border-red-200 rounded-md",
                            },
                            [
                              _c("div", { staticClass: "flex" }, [
                                _c(
                                  "svg",
                                  {
                                    staticClass: "w-5 h-5 text-red-400",
                                    attrs: {
                                      fill: "currentColor",
                                      viewBox: "0 0 20 20",
                                    },
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        "fill-rule": "evenodd",
                                        d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z",
                                        "clip-rule": "evenodd",
                                      },
                                    }),
                                  ]
                                ),
                                _c("div", { staticClass: "ml-3" }, [
                                  _c(
                                    "p",
                                    { staticClass: "text-sm text-red-700" },
                                    [_vm._v(_vm._s(_vm.addressError))]
                                  ),
                                  _c(
                                    "p",
                                    {
                                      staticClass: "text-xs text-red-600 mt-1",
                                    },
                                    [
                                      _vm._v(
                                        'Try searching for a street address like "123 Main Street, Toronto, ON"'
                                      ),
                                    ]
                                  ),
                                ]),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        }),
      ],
      1
    ),
    !_vm.isClient
      ? _c("div", { staticClass: "mb-4" }, [
          _c("div", { staticClass: "flex items-center gap-2 mb-2" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.internalCheckGeo,
                  expression: "internalCheckGeo",
                },
              ],
              staticClass:
                "w-4 h-4 rounded border-gray-300 text-primary-500 focus:ring-primary-500",
              attrs: { type: "checkbox", id: "geofence-enabled" },
              domProps: {
                checked: Array.isArray(_vm.internalCheckGeo)
                  ? _vm._i(_vm.internalCheckGeo, null) > -1
                  : _vm.internalCheckGeo,
              },
              on: {
                change: [
                  function ($event) {
                    var $$a = _vm.internalCheckGeo,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.internalCheckGeo = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.internalCheckGeo = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.internalCheckGeo = $$c
                    }
                  },
                  _vm.onCheckGeoChange,
                ],
              },
            }),
            _c(
              "label",
              {
                staticClass: "text-sm font-medium cursor-pointer select-none",
                class: _vm.internalCheckGeo ? "text-gray-900" : "text-gray-500",
                attrs: { for: "geofence-enabled" },
              },
              [_vm._v(" Geofence check in radius size is 70 metres. ")]
            ),
          ]),
          _vm.internalCheckGeo
            ? _c(
                "div",
                {
                  staticClass:
                    "flex items-center gap-2 wraningBorder flex-wrap text-black/88",
                },
                [
                  _c(
                    "div",
                    { staticClass: "flex gap-2 items-center" },
                    [
                      _c("InfoCircleFilled"),
                      _c("span", { staticClass: "text-sm" }, [
                        _vm._v("Geofencing is enabled for this visit"),
                      ]),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
        ])
      : _vm._e(),
    _vm.showMap
      ? _c("div", { staticClass: "map-container" }, [
          !_vm.isClient
            ? _c("div", [
                _c("div", { ref: "mapContainer", staticClass: "map-element" }),
                _vm.googleMapsLink
                  ? _c(
                      "a",
                      {
                        staticClass: "google-maps-link",
                        attrs: { href: _vm.googleMapsLink, target: "_blank" },
                      },
                      [_vm._v(" View on Google Maps ")]
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }